// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c3e9f435","732":"1448a7c2"}[chunkId] + ".chunk.js";
};